import { render, staticRenderFns } from "./DiskUsage.vue?vue&type=template&id=d4902a76&"
import script from "./DiskUsage.vue?vue&type=script&lang=js&"
export * from "./DiskUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports